import React, { useEffect, useState } from 'react';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import SingleProductOverview from '../SingleProductOverview';
import {
  defaultThemeProperties,
  productOverviewDefaultProps,
  productOverviewPropTypes,
  themeProperties,
  isEventBusCreated,
} from '../../helpers';
import { dataModel } from '../../dataModel';
import { track } from '../../product-overview-analytics';
import { MultiProductOverviews } from '../MultiProductOverviews';

const CONFIGURATOR_ITEM_IDS_EVENT = 'configurator.item_ids';

export const ProductOverviewAccordionBodyComponent = (props) => {
  const {
    itemId,
    showRichContentsOnly,
    hideRichContents,
    preview,
    quickLinks,
    showReturnMessage,
    revJet,
    forceMobile
  } = props;
  const [itemIds, setItemIds] = useState([itemId]);

  useEffect(() => {
    if (itemId) {
      setItemIds([itemId]);
    }
  }, [itemId]);

  useEffect(() => {
    if (isEventBusCreated()) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on(CONFIGURATOR_ITEM_IDS_EVENT, ({ output }) => {
        setItemIds(output.itemIds);
      });
    }
    return () => {
      if (isEventBusCreated()) {
        window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off(CONFIGURATOR_ITEM_IDS_EVENT);
      }
    };
  }, []);

  useEffect(() => {
    const salientType = sessionStorage.getItem('salient-points-view-more-details') || '';
    track('accordion-open', { salientType });
  }, []);

  return (
    <div
      data-section="product-overview"
      data-component="ProductOverviewAccordionBody"
      className="sui-w-full"
    >
      {itemIds.length > 1
        ? <MultiProductOverviews itemIds={itemIds} />
        : (
          <SingleProductOverview
            itemId={itemIds[0]}
            showRichContentsOnly={showRichContentsOnly}
            hideRichContents={hideRichContents}
            preview={preview}
            quickLinks={quickLinks}
            showReturnMessage={showReturnMessage}
            revJet={revJet}
            forceMobile={forceMobile}
          />
        )}
    </div>
  );
};

ProductOverviewAccordionBodyComponent.displayName = 'ProductOverviewAccordionBodyComponent';

ProductOverviewAccordionBodyComponent.dataModel = dataModel;

ProductOverviewAccordionBodyComponent.themeProps = themeProperties;

ProductOverviewAccordionBodyComponent.defaultThemeProps = defaultThemeProperties;

ProductOverviewAccordionBodyComponent.propTypes = productOverviewPropTypes;

ProductOverviewAccordionBodyComponent.defaultProps = productOverviewDefaultProps;

const ProductOverviewAccordionBody = withErrorBoundary(ProductOverviewAccordionBodyComponent);

ProductOverviewAccordionBody.displayName = 'ProductOverviewAccordionBody';

ProductOverviewAccordionBody.dataModel = dataModel;

ProductOverviewAccordionBody.propTypes = productOverviewPropTypes;

ProductOverviewAccordionBody.defaultProps = productOverviewDefaultProps;

ProductOverviewAccordionBody.themeProps = themeProperties;

ProductOverviewAccordionBody.defaultThemeProps = defaultThemeProperties;

ProductOverviewAccordionBody.dataModel = dataModel;

export { ProductOverviewAccordionBody };
